module.exports = __webpack_public_path__ + "da88e4de60eaec16561f83d1f2decd57.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/fr.json
// module id = 1126
// module chunks = 0